import { TimelinePost } from '@/types/post'
import { UserInfo } from '@/components/PostCard/components/UserInfo'
import { PostFooter } from '@/components/PostCard/components/PostFooter'
import { LinkedContent } from '@/components/PostCard/components/LinkedContent'
import { SuggestedTopics } from '@/components/PostCard/components/SuggestedTopics'
import { PostMedia } from '@/components/PostCard/components/PostMedia'
import { PostEngagement } from '@/components/PostCard/components/PostEngagement'
import { PostTags } from '@/components/PostCard/components/PostTags'
import { linkifyText } from '@/components/PostCard/utils'

interface PostCardContentProps {
  post: TimelinePost
  status?: 'pending' | 'approved' | 'rejected'
}

export function PostCardContent({ post, status }: PostCardContentProps) {
  return (
    <>
      <UserInfo post={post} />
      {post.title && (
        <h3 className="font-semibold text-lg">{post.title}</h3>
      )}
      <p className="text-gray-700 leading-relaxed line-clamp-3">{linkifyText(post.content)}</p>
      <PostMedia post={post} />
      <PostEngagement post={post} />
      <PostTags post={post} />
      <PostFooter post={post} status={status} />
      {post.metadata?.linkedTo && (
        <LinkedContent
          territory={post.metadata.linkedTo.territory}
          brand={post.metadata.linkedTo.brand}
        />
      )}
      {post.metadata?.suggestedTopics && (
        <SuggestedTopics topics={post.metadata.suggestedTopics} />
      )}
    </>
  )
}
